import { createContext, type PropsWithChildren } from "react";
import { type PropsWithTestID } from "@boi/components-core";

import { type TabsProps } from "./Tabs";

type TabsContextValue = PropsWithTestID &
  Pick<
    TabsProps,
    | "items"
    | "activeItemId"
    | "mobileHeading"
    | "desktopHeading"
    | "desktopHeadingLevel"
    | "onChange"
    | "withPadding"
  >;

const TabsContext = createContext<TabsContextValue>({} as TabsContextValue);

export type TabsProviderProps = TabsContextValue & PropsWithChildren;

export const TabsProvider = (props: TabsProviderProps) => {
  const { children, ...providerValue } = props;

  return (
    <TabsContext.Provider value={providerValue}>
      {children}
    </TabsContext.Provider>
  );
};

export default TabsContext;
